import React from 'react';
interface ChanceCardProps {
  type: 'chance' | 'chest';
  title: string;
  description: string;
}
export function ChanceCard({
  type,
  title,
  description
}: ChanceCardProps) {
  const isChance = type === 'chance';
  const bgColor = isChance ? '#FF9F00' : '#3CB4E5'; // Orange vs Blue
  const icon = isChance ? '?' : '⚡';
  return <div className="relative w-full max-w-[320px] aspect-[1.6/1] bg-white border-2 border-black shadow-[6px_6px_0px_0px_rgba(0,0,0,1)] p-6 flex flex-col items-center justify-center text-center transform rotate-1 hover:rotate-0 transition-transform duration-300" data-id="element-1">
      <div className="absolute top-4 left-4 text-4xl font-bold opacity-20 font-serif" data-id="element-2">
        {icon}
      </div>
      <div className="absolute bottom-4 right-4 text-4xl font-bold opacity-20 font-serif" data-id="element-3">
        {icon}
      </div>

      <h3 className="font-['Koulen'] text-3xl uppercase mb-3 tracking-widest" style={{
      color: bgColor
    }} data-id="element-4">
        {isChance ? 'SZANSA' : 'KASA SPOŁECZNA'}
      </h3>

      <p className="font-['Aleo'] text-lg font-medium italic leading-tight" data-id="element-5">
        {description}
      </p>
    </div>;
}